import React from 'react'
import ActionButtons from '../ActionButtons/ActionButtons'

const TitleSection = ({ contentfulTranslations, fileAttachment }) => {
  return (
    <div className='flex items-center buy-list-title'>
      <h2>{contentfulTranslations.youNeedTitle}</h2>
      <div className='hide-mobile hide-on-print'>
        <ActionButtons contentfulTranslations={contentfulTranslations} fileAttachment={fileAttachment} />
      </div>
    </div>
  )
}

export default TitleSection
